import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-17",
  "use": "icon-button_icon-17-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-17\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M23 8v12a2 2 0 01-2 2H3a2 2 0 01-2-2V8\" /><path stroke-linecap=\"round\" d=\"M12 11l3 3M9 14l3-3\" /><path stroke-linejoin=\"round\" d=\"M6 2h12l5 6H1z\" /><path stroke-linecap=\"round\" d=\"M12 11.449v7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol